import { render, staticRenderFns } from "./EventPancancerPsi.vue?vue&type=template&id=78a0b596&scoped=true&"
import script from "./EventPancancerPsi.vue?vue&type=script&lang=js&"
export * from "./EventPancancerPsi.vue?vue&type=script&lang=js&"
import style0 from "./EventPancancerPsi.vue?vue&type=style&index=0&id=78a0b596&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0b596",
  null
  
)

export default component.exports